import React from 'react'
import Image from 'next/image'
import { Header2 } from '../../styles/Components'
import { AsSeenInWrapper } from './styles'

const images = [
  { logo: '/weddings/bridesLogo.png', alt: 'brides.com', url: 'https://www.brides.com/story/best-beauty-service-apps-for-wedding' },
  { logo: '/weddings/KnotLogo.png', alt: 'theknot.com', url: 'https://www.theknot.com/marketplace/glamsquad-new-york-ny-850220' },
  { logo: '/weddings/allureLogo.png', alt: 'allure.com', url: 'https://www.allure.com/story/glamsquad-changing-womens-lives' },
  { logo: '/weddings/worldbridemagazine-logo-black.png', alt: 'worldbridemagazine.com', url: 'https://worldbridemagazine.com/45755/glamsquad-confidence-convenience-and-bridal-beauty-with-giovanni-vaccaro/' },
]

const AsSeenIn = () => {
  return (
    <AsSeenInWrapper>
      <Header2 margin="0 0 32px">As seen in</Header2>
      <div className="bridal-mags">
        {images.map((img, i) => (
          <div key={i} className="wedding-as-seen-logo">
            <a href={img.url} target="_blank" rel="noopener noreferrer">
              <Image
                src={img.logo}
                alt={img.alt || 'Bridal-Magazine'}
                width={150}
                height={50}
                style={{ objectFit: 'contain', width: '100%', height: 'auto' }}
              />
            </a>
          </div>
        ))}
      </div>
    </AsSeenInWrapper>
  )
}

export default AsSeenIn
